var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 13.5198C14.8016 14.1465 14.0857 14.5894 12.6539 15.4752C11.2697 16.3314 10.5777 16.7596 10.0199 16.5875C9.78934 16.5163 9.57925 16.3812 9.40982 16.195C9 15.7448 9 14.8715 9 13.125C9 11.3785 9 10.5052 9.40982 10.0549C9.57925 9.86881 9.78934 9.73368 10.0199 9.66253C10.5777 9.49044 11.2697 9.91857 12.6539 10.7748C14.0857 11.6606 14.8016 12.1035 14.9531 12.7302C15.0156 12.9889 15.0156 13.2611 14.9531 13.5198Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4977 11.625C21.5 12.0951 21.5 12.5943 21.5 13.125C21.5 17.6033 21.5 19.8425 20.1088 21.2338C18.7175 22.625 16.4783 22.625 12 22.625C7.52166 22.625 5.28249 22.625 3.89124 21.2338C2.5 19.8425 2.5 17.6033 2.5 13.125C2.5 8.64666 2.5 6.40749 3.89124 5.01624C5.28249 3.625 7.52166 3.625 12 3.625C12.5307 3.625 13.0299 3.625 13.5 3.62731",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.625L19.2579 3.32203C19.5961 4.23602 19.7652 4.69302 20.0986 5.02639C20.432 5.35977 20.889 5.52887 21.803 5.86708L22.5 6.125L21.803 6.38292C20.889 6.72113 20.432 6.89024 20.0986 7.22361C19.7652 7.55698 19.5961 8.01398 19.2579 8.92797L19 9.625L18.7421 8.92797C18.4039 8.01398 18.2348 7.55698 17.9014 7.22361C17.568 6.89024 17.111 6.72113 16.197 6.38292L15.5 6.125L16.197 5.86708C17.111 5.52887 17.568 5.35977 17.9014 5.02639C18.2348 4.69302 18.4039 4.23602 18.7421 3.32203L19 2.625Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.edb1bf71510e42e460f4955b7af48196.svg";
export { ForwardRef as ReactComponent };